import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import ErrorBoundary from 'components/ErrorBoundary';

import useCouponPicker from 'hooks/useCouponPicker';
import useExclusiveCoupon from 'hooks/useExclusiveCoupon';

import { isFirstItem } from 'lib/array';
import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import CouponListItem from './CouponListItem';

const FinishedCouponsList = ({
  className,
  coupons,
  gaEventCategory,
  storeName,
  storeSlug,
}) => {
  const {
    isCouponBlocked,
    formatGaEventActionByVisibility,
    onUnloggedUserTriesOpenExclusiveCoupon,
  } = useExclusiveCoupon();
  const { openCouponPicker } = useCouponPicker(gaEventCategory);

  return (
    <ErrorBoundary>
      <section className={className}>
        <Heading as="h2" className="text-neutral-low-400" size="size4">
          Cupons expirados de {storeName}
        </Heading>
        <Text className="mb-2 mt-2 text-neutral-high-500 lg:mb-4">
          {placeholder('descriptions.expiredCouponCanDisclaimer')}
        </Text>
        {coupons.map(
          ({ couponCode, couponId, couponTitle, visibility }, index) => (
            <CouponListItem
              key={couponId}
              className={
                !isFirstItem(index) &&
                'border border-solid border-transparent border-t-neutral-high-300'
              }
              couponCode={couponCode}
              couponId={couponId}
              couponTitle={couponTitle}
              gaEventCategory={gaEventCategory}
              visibility={visibility}
              onOpenCouponPicker={() => {
                sendEvent({
                  action: formatGaEventActionByVisibility(
                    'coupon_click',
                    visibility
                  ),
                  category: gaEventCategory,
                });

                if (isCouponBlocked(visibility)) {
                  onUnloggedUserTriesOpenExclusiveCoupon(visibility, () => {
                    openCouponPicker({ couponId, storeName, storeSlug });
                  });
                  return;
                }

                openCouponPicker({ couponId, storeName, storeSlug });
              }}
            />
          )
        )}
      </section>
    </ErrorBoundary>
  );
};

FinishedCouponsList.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  coupons: PropTypes.arrayOf(
    PropTypes.shape({
      couponId: PropTypes.number.isRequired,
      couponDiscountValue: PropTypes.string.isRequired,
      couponDiscountShort: PropTypes.string.isRequired,
      couponDiscount: PropTypes.string.isRequired,
      couponDiscountOn: PropTypes.string.isRequired,
      couponStatusName: PropTypes.string.isRequired,
      couponInstructions: PropTypes.string.isRequired,
      couponVerified: PropTypes.bool,
      storeImage: PropTypes.string,
      storeName: PropTypes.string.isRequired,
      storeDomain: PropTypes.string.isRequired,
      storeSlug: PropTypes.string.isRequired,
      couponTag: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      couponPublished: PropTypes.string.isRequired,
      couponTitle: PropTypes.string.isRequired,
      couponCode: PropTypes.string.isRequired,
      couponUrl: PropTypes.string.isRequired,
      userName: PropTypes.string,
    })
  ).isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
};

export default FinishedCouponsList;
